import APIModel from "../../Models/APIModel";
import axios from "axios";

// done
export const getRoles = (token) => {
  return axios.get(APIModel.HOST + "User/getAssignRoleListForUser", {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

//done
export const getUserRoles = (token, id) => {
  return axios.get(APIModel.HOST + "User/GetUserRoles?PID=" + id, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

//done
export const getPermissions = (token) => {
  return axios.get(APIModel.HOST + "Admin/GetAllPermissions", {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

//done
export const getRolePermissions = (token, id) => {
  return axios.get(APIModel.HOST + "User/RolePermissions?RoleID=" + id, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

//done
export const getUserPermissions = (token, id) => {
  return axios.get(APIModel.HOST + "User/GetPermissions?CUserID=" + id, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

export const createRole = (token, params) => {
  return axios.post(APIModel.HOST + "Admin/CreateRole", params, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

export const createPermission = (token, params) => {
  return axios.post(APIModel.HOST + "Admin/CreatePermission", params, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

export const editRolePermissions = (token, id, permissions) => {

  let str = "";

  permissions.forEach(p => str += `${p},`);

  const params = {
    RoleID: id,
    Permissions: str.substring(0, str.length - 1)
  };

  return axios.post(APIModel.HOST + "Admin/EditRolesPermission", params, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};

export const editUserRoles = (token, id, roles) => {

  let str = "";

  roles.forEach(p => {
    if (p !== 0) {
      str += `${p},`
    }
  });

  const params = {
    UserID: `${id}`,
    Roles: str.substring(0, str.length - 1)
  };

  console.log(params);

  return axios.post(APIModel.HOST + "Admin/EditUsersRole", params, {
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'token': token
    }
  });
};
